<a
  *ngIf="!link.newTab; else newTab"
  (click)="link.clickFn(link.clickFnParam)"
  class="in-line alc-ellipsis"
  [matTooltip]="link.text"
  appMatTooltipShowIfTruncated>
  <strong>{{ link.text }}</strong>
</a>
<ng-template #newTab>
  <span class="alc-icon-and-name in-line">
    <strong class="alc-ellipsis in-line" [matTooltip]="link.text" appMatTooltipShowIfTruncated>{{ link.text }}</strong
    >&nbsp;
    <a (click)="link.clickFn(link.clickFnParam)" class="alc-icon-and-name">
      <mat-icon>open_in_new</mat-icon>
    </a>
  </span>
</ng-template>
